<template>
	<section class="app-container bg--secondary">
		<div class="container" v-if="!loading">
		  	<router-link class="btn btn-sm pull-right" :to="{ name: 'profile', params: { id: current_user.id }}">View Profile</router-link>
            <a class="btn btn-sm pull-right" style="margin-right: 10px;" onclick="mr.modals.showModal($('#changepassword'));">Change Password</a>
            
			<h2>Edit Your Account</h2>
			<div class="feature feature-1 boxed boxed--border">
				<h5>Basic Information</h5>
				<div class="row">
					<div class="col-12 col-md-6 col-lg-3">
						<label>Username:</label>
						<input v-model="current_user.username" type="username" placeholder="Your Username" />
						<error-list v-bind:errors="error_results.username"></error-list>
					</div>
					<div class="col-12 col-md-6 col-lg-3">
						<label>Email:</label>
						<input v-model="current_user.email" type="email" placeholder="Your Email Address" />
						<error-list v-bind:errors="error_results.email"></error-list>
					</div>
					<div class="w-100"></div>
					<div class="col-12 col-md-6 col-lg-3">
						<label>First Name:</label>
						<input v-model="current_user.first_name" type="text" placeholder="Your First Name" />
						<error-list v-bind:errors="error_results.first_name"></error-list>
					</div>
					<div class="col-12 col-md-6 col-lg-3">
						<label>Last Name:</label>
						<input v-model="current_user.last_name" type="text" placeholder="Your Last Name" />
						<error-list v-bind:errors="error_results.last_name"></error-list>
					</div>
					<div class="w-100"></div>
					<div class="col-12 col-md-6 col-lg-3">
						<label>Show real name to all users:</label> <i class="fa fa-info-circle" data-tooltip="If you check No, your real name will be shown to vetters and admins but your user name will be shown to everyone else."></i><br />
						<div class="input-radio input-radio--innerlabel">
							<input id="registerDirectoryIncludeYes" type="radio" name="registerDirectoryInclude" v-model="current_user.profile.include_in_directory" v-bind:value="true">
							<label for="registerDirectoryIncludeYes">Yes</label>
						</div>
						<div class="input-radio input-radio--innerlabel">
							<input id="registerDirectoryIncludeNo" type="radio" name="registerDirectoryInclude" v-model="current_user.profile.include_in_directory" v-bind:value="false">
							<label for="registerDirectoryIncludeNo">No</label>
						</div>
						<error-list v-bind:errors="error_results.profile.include_in_directory"></error-list>
					</div>
					<div class="col-12 col-md-6 col-lg-3">
						<label>iNaturalist Username:</label> <i class="fa fa-info-circle" data-tooltip="Your iNaturalist username will be used to associate your account with data imported from iNaturalist projects."></i><br />
						<input v-model="current_user.profile.inaturalist_username" type="text" placeholder="Your iNaturalist Username" />
						<error-list v-bind:errors="error_results.profile.inaturalist_username"></error-list>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-md-7">
					<h4>Optional Information</h4>
					<div class="feature feature-1 boxed boxed--border">
						<h4>Contact</h4>
						<div class="row">
							<div class="col-12 col-md-6">
								<label>Phone:</label>
								<input v-model="current_user.profile.phone" type="text" placeholder="Phone Number" />
								<error-list v-bind:errors="error_results.profile.phone"></error-list>
							</div>
							<div class="col-12 col-md-6">
								<label>Fax:</label>
								<input v-model="current_user.profile.fax" type="text" placeholder="Fax Number" />
								<error-list v-bind:errors="error_results.profile.fax"></error-list>
							</div>
							<div class="w-100"></div>
							<!-- <div class="col-12 col-md-6">
								<label>Fax:</label>
								<input v-model="current_user.profile.website" type="text" placeholder="website Number" />
								<error-list v-bind:errors="error_results.profile.website"></error-list>
							</div> -->
						</div>
						<br />
						<h4>Address</h4>
						<div class="row">
							<div class="col-12 col-md-6">
								<label>Address Line 1:</label>
								<input v-model="current_user.profile.address_1" type="text" placeholder="Your Address" />
								<error-list v-bind:errors="error_results.profile.address_1"></error-list>
							</div>
							<div class="col-12 col-md-6">
								<label>Address Line 2:</label>
								<input v-model="current_user.profile.address_2" type="text" placeholder="Your Address details" />
								<error-list v-bind:errors="error_results.profile.address_2"></error-list>
							</div>
							<div class="w-100"></div>
							<div class="col-12 col-md-6">
								<label>City:</label>
								<input v-model="current_user.profile.city" type="text" placeholder="City" />
								<error-list v-bind:errors="error_results.profile.City"></error-list>
							</div>
							<div class="col-12 col-md-6">
								<label>State:</label>
								<input v-model="current_user.profile.state_province" type="text" placeholder="State" />
								<error-list v-bind:errors="error_results.profile.state_province"></error-list>
							</div>
							<div class="w-100"></div>
							<div class="col-12 col-md-6">
								<label>Zip Code:</label>
								<input v-model="current_user.profile.zip" type="text" placeholder="Zip Code" />
								<error-list v-bind:errors="error_results.profile.zip"></error-list>
							</div>
							<div class="col-12 col-md-6">
								<label>Country:</label>
								<input v-model="current_user.profile.country" type="text" placeholder="Country " />
								<error-list v-bind:errors="error_results.profile.country"></error-list>
							</div>
							<div class="w-100"></div>
						</div>
					</div>
				</div>
				<div class="col-md-5">
					<h4>Favorite Locations</h4>
					<div class="feature feature-1 boxed boxed--border">
						<ul>
							<li v-for="favorite in current_user.profile.favorite_locations" class="notranslate" translate="no">
								<router-link :to="{ path: '/data/records/', query: { filterqs: '|locations:' + favorite.id }}">
									{{favorite.display_name}}
								</router-link>
							</li>
						</ul>
						<router-link class="btn btn-xs btn-block" :to="{ name: 'my-locations'}">
							Manage All Locations
						</router-link>
					</div>
				</div>
			</div>
			<button class="btn btn--primary btn-block btn-lg" @click="save_user()">Save Profile</button>
			<button style="display:block;margin: 50px auto 0 auto; color:red;" class="btn btn-sm" onclick="mr.modals.showModal($('#DeleteAccount'));">Delete Account</button>

			<div class="modal-container" id="changepassword">
                <div class="modal-content section-modal">
                    <section class="unpad">
                        <div class="container">
                            <div class="row justify-content-center">
                                <div class="col-md-6">
                                    <div class="feature feature-1">
                                        <div class="feature__body boxed boxed--lg boxed--border">
                                            <div class="modal-close modal-close-cross"></div>
                                            <div class="text-block">
                                                <h3 class=" text-center">Change Password</h3>
                                                <label>Current Password:</label>
												<input type="password" v-model="currentPassword" />
								                <error-list v-bind:errors="change_password_error_results.current_password"></error-list>
                                                <label>New Password:</label>
												<input type="password" v-model="newPassword" />
								                <error-list v-bind:errors="change_password_error_results.new_password"></error-list>
										  		<label>Confirm Password:</label>
												<input type="password" v-model="newPasswordConfirmed" />
								                <error-list v-bind:errors="change_password_error_results.re_new_password"></error-list>
								                <error-list v-bind:errors="change_password_error_results.non_field_errors"></error-list>
												<button @click="saveNewPassword()" class="btn btn-primary btn-block">Save</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>

            <div class="modal-container" id="DeleteAccount">
                <div class="modal-content section-modal">
                    <section class="unpad">
                        <div class="container">
                            <div class="row justify-content-center">
                                <div class="col-md-6">
                                    <div class="feature feature-1">
                                        <div class="feature__body boxed boxed--lg boxed--border">
                                            <div class="modal-close modal-close-cross"></div>
                                            <div class="text-block">
                                                <h3>Delete Account</h3>
                                                <p><strong>Are you sure you want to delete your account? This action is permanent and cannot be undone.</strong></p>
                                                <br />
                                                <p>If you are sure, please enter your password and click DELETE ACCOUNT below.</p>
                                                <br />
                                                <label>Username:</label>
												<input type="text" v-model="deleteUsername" />
                                                <label>Password:</label>
												<input type="password" v-model="deletePassword" />
												<error-list v-bind:errors="delete_account_error_results"></error-list>
												<button @click="deleteUser()" class="btn btn-danger btn-block">DELETE ACCOUNT</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'AccountPage',
	metaInfo: {
      title: 'My Account',
    },
	data: function(){
		return {
			loading: true,
			current_user: null,
			error_results: {
				profile: {}
			},
			change_password_error_results: [],
			newPasswordConfirmed:null,
			newPassword:null,
			currentPassword:null,
			deletePassword:null,
			deleteUsername:null,
			delete_account_error_results: [],
		};
	},
	mounted(){
		this.get_user();
	},
	methods:{
		saveNewPassword: function(){
			if (!this.newPassword || !this.newPasswordConfirmed) {
				self.$notify({
                    title: 'Please enter and confirm your password.',
                    type: 'error',
                });
                return;
			}

			var self = this;
			this.API({
                endpoint: 'auth/users/set_password',
                funcThen: function(response){
                	self.$notify({
	                    title: 'Your password has been updated.',
	                    type: 'success',
	                });
                	mr.modals.closeActiveModal();
                	self.newPasswordConfirmed = null;
					self.newPassword = null;
					self.currentPassword = null;
                },
                funcCatch: function(error){
                    if (error.response && error.response.data) {
                        self.change_password_error_results = error.response.data;
                    }
                    else{
                        console.log(error);
                    }
                },
                isPost:true,
                postData: { 
					current_password: self.currentPassword,
					new_password: self.newPassword,
					re_new_password: self.newPasswordConfirmed
                }
            });
		},
		get_user: function(){
			var self = this;
			self.loading = true;
			self.GetAPIUser(function(user){
				self.current_user = user;
				self.loading = false;
			}, true);
		},
		reset_error_results: function(){
			this.error_results = {profile: {}};
		},
		save_user: function(){
			var self = this;
			self.reset_error_results();

			var payload = self.current_user;
			delete payload.groups;

			this.API({
				endpoint: 'auth/users/me',
				funcThen: function(response){
					self.current_user = response.data;
					self.$notify({
					  title: 'Profile Information Saved',
					  type: 'success',
					});
				},
				funcCatch: function(error){
					var tmp = error.response.data;
					if (!tmp.profile) {
						tmp.profile = {};
					}
					self.error_results = tmp;
				},
				isPatch:true,
				postData: self.current_user
			});
		},
		deleteUser: function(){
			var self = this;
			this.API({
				endpoint: 'user',
				funcThen: function(response){
					self.$notify({
					  title: 'Your account has been deleted.',
					  type: 'success',
					});
					self.loading = true;
				},
				funcCatch: function(error){
					self.delete_account_error_results = error.response.data;
				},
				isDelete:true,
				postData: {
					'password': self.deletePassword,
					'username': self.deleteUsername
				}
			});
		}
	},
}
</script>


// WEBPACK FOOTER //
// src/components/pages/Account.vue